import React, {createContext, useReducer} from 'react';
import { leagueReducer, leaguesReducer, predictionReducer, snackbarReducer, userReducer } from './reducers';
import { countries, groups, matches, questions, stadiums, teams } from '../assets/static'
import { menuItems } from '../assets/configs'
import { CLOSUREDATE } from '../assets/configs/constants';

const u = {uid: '8ze94rv5uKVbGLubMGTXOyICZkW2', creationDate: 'Tue, 04 Jul 2023 21:18:04 GMT', displayName: 'Rob Wegbrands', email: 'rob.wegbrands@gmail.com', photoURL: 'https://lh3.googleusercontent.com/a/AAcHTtecZ809O14aXUUnoW0cvonz4ee4Pjh82mM1ny0K8KULuWk=s96-c'}
const today = new Date();

function getFilteredTeams(unfilteredTeams) {

  let filteredTeams = []
  let groupTeams = []

  // Pull all teams for all groups currently active
  groups.forEach((g) => {
    g.teams.forEach((gt) => {
      groupTeams.push(gt);
    })
  })

  // for each team, check if it's in the group Teams and if so push to Teams
  unfilteredTeams.forEach((uft) => {
    if(groupTeams.includes(uft._id)) {
      filteredTeams.push(uft);
    }
  })

  return filteredTeams
}

const initialState = { // todo: multiple to single (e.g. change countries to country, groups to group , etc.)
    countries: countries, // todo
    closedForEditing: today > CLOSUREDATE,
    groups: groups, // todo
    league: null,
    leagues: [],
    matches: matches, // todo
    menuItems: menuItems, // todo
    prediction: null,
    predictionAnswers: null,
    questions: questions,
    rankedList: [],
    snackbar: null,
    stadiums: stadiums, // todo
    teams: getFilteredTeams(teams),
    user: null
    //user: u
};
const globalStore = createContext(initialState);
const { Provider } = globalStore;

const combineReducers = reducers => {
  return (state, action) => {
    return Object.keys(reducers).reduce(
      (acc, prop) => {
        return ({
          ...acc,
          ...reducers[prop]({ [prop]: acc[prop] }, action),
        })
      },
      state
    )
  }
}

const StateProvider = ( { children } ) => {

  const reducers = combineReducers({
    league: leagueReducer,
    leagues: leaguesReducer,
    prediction: predictionReducer,
    snackbar: snackbarReducer,
    user: userReducer,
  })

  const [state, dispatch] = useReducer(reducers, initialState)
  const store = React.useMemo(() => [state, dispatch], [state]); // memoize. Else all context consumers update on *every* render

  return <Provider value={store}>{children}</Provider>;
};

export { globalStore, StateProvider }